import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import {
  Button,
  Input,
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from "@learn-me/ui";
import { useAuth } from "@/features/auth/hooks/useAuth";
import type { ResetPasswordRequest } from "@learn-me/types";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const { resetPassword, resetPasswordLoading } = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<{ password: string; confirmPassword: string }>();

  const onSubmit = (data: { password: string }) => {
    resetPassword({ token, password: data.password });
  };

  const password = watch("password");

  if (!token) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center py-12 px-4">
        <Card className="w-full max-w-md">
          <CardContent className="py-8 text-center">
            <h1 className="text-xl font-bold text-destructive mb-2">
              Token Invalido
            </h1>
            <p className="text-muted-foreground">
              El enlace de recuperacion es invalido o ha expirado.
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-[80vh] flex items-center justify-center py-12 px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <h1 className="text-2xl font-bold">Nueva Contrasena</h1>
          <p className="text-muted-foreground">Ingresa tu nueva contrasena</p>
        </CardHeader>
        <form onSubmit={handleSubmit(onSubmit)}>
          <CardContent className="space-y-4">
            <Input
              label="Nueva contrasena"
              type="password"
              placeholder="********"
              error={errors.password?.message}
              {...register("password", {
                required: "La contrasena es requerida",
                minLength: {
                  value: 8,
                  message: "Minimo 8 caracteres",
                },
              })}
            />
            <Input
              label="Confirmar contrasena"
              type="password"
              placeholder="********"
              error={errors.confirmPassword?.message}
              {...register("confirmPassword", {
                required: "Confirma tu contrasena",
                validate: (value) =>
                  value === password || "Las contrasenas no coinciden",
              })}
            />
          </CardContent>
          <CardFooter>
            <Button
              type="submit"
              className="w-full"
              isLoading={resetPasswordLoading}
            >
              Cambiar Contrasena
            </Button>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
}
